import React from 'react';
import { Text } from '@react-pdf/renderer';

export const P = ({
  children,
  marginBottom = 10,
  style = {}
}) => (<Text
  style={{ marginBottom, ...style }}
>
  {children}
</Text>);
